/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Form, InputNumber, Modal, Select, Typography } from 'antd';
import { useEffect, useState } from 'react';
import {
    addMaxQuantityRestriction,
    getProducts,
    updateMaxQuantityRestriction,
} from '../../../redux/actions/products';
import { getProductImageUrl } from '../../../utils';
import { parseInt } from 'lodash';

const { Text } = Typography;

const AddQuantityRestriction = ({ data, open, onClose, afterCreate }) => {
    const [form] = Form.useForm();
    const [products, setProducts] = useState([]);

    const selectedProductId = Form.useWatch('product_netsuite_id', form);
    const productImage = getProductImageUrl(
        products.find((p) => parseInt(p.netsuite_id) === parseInt(selectedProductId))
    );

    const fetchProducts = async () => {
        const res = await getProducts();
        if (res?.ack) {
            setProducts(res.products);
        }
    };

    const handleFormSubmit = async (values) => {
        const product = products.find(
            (p) => parseInt(p.netsuite_id) === parseInt(values.product_netsuite_id)
        );
        const body = {
            ...values,
            product_code: product?.code,
            product_name: product?.name,
        };
        if (data) body.id = data.id;

        const res = data
            ? await updateMaxQuantityRestriction(body)
            : await addMaxQuantityRestriction(body);

        if (res?.ack) {
            onClose();
            afterCreate?.()
        }
    };

    const handleKeyDown = (e) => {
        if (
            !(
                (e.key >= '0' && e.key <= '9') ||
                ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(e.key)
            )
        ) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        fetchProducts();

        if (data) {
            form.setFieldsValue({
                ...data,
            });
        }
    }, [data]);

    return (
        <Modal
            title={data ? 'Update Quantity Limit' : 'Add Quantity Limit'}
            open={open}
            onCancel={onClose}
            centered
            width={800}
            okText={data ? 'Update' : 'Save'}
            onOk={() => form.submit()}
        >
            <div className="flex align-items-center gap-4 flex-wrap">
                {selectedProductId && productImage && (
                    <Avatar shape="square" size={100} src={productImage} className="mb-3" />
                )}
                <Form
                    layout="vertical"
                    form={form}
                    name="quantity_restriction"
                    size="large"
                    className="tight-form flex-1"
                    onFinish={handleFormSubmit}
                >
                    <Form.Item
                        name="product_netsuite_id"
                        label="Product"
                        rules={[{ required: true, message: 'Please select a product' }]}
                    >
                        <Select
                            placeholder="Search Product"
                            optionLabelProp="label"
                            showSearch
                            filterOption={(input, option) =>
                                String(option['data-title'] || '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase()) ||
                                String(option['data-code'] || '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            disabled={!!data}
                        >
                            {products?.map((product, idx) => (
                                <Select.Option
                                    key={idx}
                                    value={product?.netsuite_id}
                                    label={`[${product?.code}] ${product?.name}`}
                                    data-code={product?.code}
                                    data-title={product?.name}
                                >
                                    <Text>
                                        [{product?.code}] {product?.name}
                                    </Text>
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="max_quantity"
                        label="Maximum Quantity"
                        rules={[{ required: true, message: 'Please enter maximum quantity' }]}
                    >
                        <InputNumber min={0} controls={false} onKeyDown={handleKeyDown} className="w-full" />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default AddQuantityRestriction;
